import * as React from "react";
import { PriceViewGridBase } from "./styles";
export const PriceViews = (props) => {
    const { price, originPrice, className = "", isFlash } = props;
    return (React.createElement(PriceViewGridBase, { key: "PriceViews", className: className, isFlash: isFlash },
        React.createElement("span", { className: "currentPrice" }, price),
        price !== originPrice && React.createElement("span", { className: "originPrice" }, originPrice)));
};
